import posthog from 'posthog-js';

const ENV = typeof import.meta !== 'undefined' ? import.meta.env : {};

const POSTHOG_KEY =
  (ENV && ENV.VITE_POSTHOG_KEY) ||
  (typeof process !== 'undefined' && process.env && process.env.VITE_POSTHOG_KEY) ||
  (typeof process !== 'undefined' && process.env && process.env.POSTHOG_KEY) ||
  '';

const POSTHOG_HOST =
  (ENV && ENV.VITE_POSTHOG_HOST) ||
  (typeof process !== 'undefined' && process.env && process.env.VITE_POSTHOG_HOST) ||
  'https://app.posthog.com';

let initialized = false;
let ready = false;

export const ANALYTICS_EVENTS = {
  ESTIMATE_UPLOAD: 'estimate_upload',
  REVIEW_LOADED: 'review_loaded',
  ROOM_MATCH_FIXED: 'room_match_fixed',
  VARIANCE_EXPORTED: 'variance_exported',
  PDF_PARSE_ERROR: 'pdf_parse_error',
};

export function initAnalytics() {
  if (initialized || !POSTHOG_KEY || typeof window === 'undefined') {
    return ready;
  }
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false,
    autocapture: true,
    capture_pageleave: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: 'body',
      blockClass: 'ph-no-capture',
    },
    loaded: () => {
      ready = true;
    },
  });
  initialized = true;
  return ready;
}

export function isAnalyticsReady() {
  return ready;
}

export function trackEvent(name, properties = {}) {
  if (!ready) return;
  const payload = Object.fromEntries(
    Object.entries(properties || {}).filter(([, value]) => value !== undefined),
  );
  posthog.capture(name, payload);
}

export function getAnalyticsClient() {
  return ready ? posthog : null;
}

export function flushAnalytics(timeout = 2000) {
  return new Promise((resolve) => {
    if (!ready || !posthog?.flush) {
      resolve();
      return;
    }
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      resolve();
    };
    posthog.flush(finish);
    const timer = setTimeout(finish, timeout);
    if (typeof timer === 'object' && typeof timer.unref === 'function') {
      timer.unref();
    }
  });
}
